import { Box, Center, Spinner, Text, VStack, useColorMode } from "@chakra-ui/react"
import { Viewer, Worker } from "@react-pdf-viewer/core"
import "@react-pdf-viewer/core/lib/styles/index.css"
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout"
import "@react-pdf-viewer/default-layout/lib/styles/index.css"
import type { ToolbarProps, ToolbarSlot, TransformToolbarSlot } from "@react-pdf-viewer/toolbar"
import "@react-pdf-viewer/toolbar/lib/styles/index.css"
import type * as React from "react"

import { LinkButton } from "./LinkButton"

interface Props {
  url: string
}

export default function PdfViewer({ url }: Props) {
  const transform: TransformToolbarSlot = (slot: ToolbarSlot) => ({
    ...slot,
    Open: () => <></>,
    OpenMenuItem: () => <></>,
    Print: () => <></>,
    PrintMenuItem: () => <></>,
    SwitchTheme: () => <></>,
    SwitchThemeMenuItem: () => <></>,
  })

  const renderToolbar = (Toolbar: (props: ToolbarProps) => React.ReactElement) => (
    <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
  )

  const defaultLayoutPluginInstance = defaultLayoutPlugin({ renderToolbar })
  const { renderDefaultToolbar } = defaultLayoutPluginInstance.toolbarPluginInstance

  const { colorMode } = useColorMode()

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.15.349/legacy/build/pdf.worker.min.js">
      <Box h={{ base: "calc(100vh - 200px)", sm: "calc(100vh - 150px)", md: "calc(100vh - 180px)" }} w="100%">
        <Viewer
          fileUrl={url}
          theme={colorMode}
          renderError={() => (
            <Center h="400px">
              <VStack>
                <Text textAlign="center">There was an issue loading the file in Amplify</Text>
                <Text textAlign="center">This may be resolved by updating your browser</Text>
                <LinkButton variant="outline" target="_blank" isExternal borderRadius="full" href={url}>
                  Click here to view in browser
                </LinkButton>
              </VStack>
            </Center>
          )}
          renderLoader={() => (
            <Center>
              <VStack spacing={6}>
                <Spinner size="xl" />
                <Text>
                  Depending on the size of the report and your connection, this may take a minute to load.
                </Text>
              </VStack>
            </Center>
          )}
          plugins={[defaultLayoutPluginInstance]}
        />
      </Box>
    </Worker>
  )
}
